import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { EDM_LEASE_DEALS_SORT } from 'site-modules/lease-deals/constants/lease-deals-constants';
import { Select } from 'client/site-modules/shared/components/select/select';
import { DropDownEntity } from 'client/site-modules/lease-deals/components/filters/entities/options-entity';

import './sort-header-control.scss';

export const SortHeaderControl = ({ options, selectedValues = [], onChange }) => {
  const handleChange = useCallback(
    ({ title }) => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_TOOL_SELECT,
          subaction_name: 'update_sort',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          creative_id: EDM_LEASE_DEALS_SORT,
          value: title,
        },
      });
      onChange([title]);
    },
    [onChange]
  );

  return (
    <div className="lease-deals-sort-by size-14 pos-r">
      <Select
        id="sort-by"
        name="sort-by"
        className="pos-a top-0 left-0 w-100 h-100"
        valueKey="title"
        labelKey="text"
        value={selectedValues[0]}
        options={options}
        isFirstOptionDisabled={false}
        onChange={handleChange}
        isLabelHidden
        inputClassName="pos-a left-0 right-0"
      />
      <label htmlFor="sort-by" className="pos-r m-0 top-0 left-0">
        <span className="text-white fw-medium">
          Sort by: <i className="icon-sort align-middle" aria-hidden />
        </span>
      </label>
    </div>
  );
};

SortHeaderControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: DropDownEntity.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
};
